import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const PlayFilled = createSvgIcon(
  <path d="M2.266.019 21.86 12 2.266 23.982V.019Z" />,
  'PlayFilled'
);

export { PlayFilled };